var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgPencil(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 19,
    height: 19,
    viewBox: "0 0 19 19",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M11.3631 3.25816L12.843 1.77817C13.6241 0.99712 14.8904 0.99712 15.6715 1.77817L17.0857 3.19239C17.8667 3.97343 17.8667 5.23976 17.0857 6.02081L15.6057 7.5008M11.3631 3.25816L1.74742 12.8738C1.41535 13.2059 1.21072 13.6442 1.1694 14.112L0.927315 16.8525C0.872545 17.4725 1.39141 17.9914 2.01143 17.9366L4.75184 17.6945C5.21965 17.6532 5.658 17.4485 5.99007 17.1165L15.6057 7.5008M11.3631 3.25816L15.6057 7.5008",
    stroke: "#007755",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPencil);
export default __webpack_public_path__ + "static/media/pencil.1dff58bf40afeb225a361cdc019b938b.svg";
export { ForwardRef as ReactComponent };